import { api } from '@services';

import Organization, {
  IOrganization,
  IOrganizationApiModel,
} from '@models/Organization.model';

const getOrganization = async (): Promise<IOrganization> => {
  const { data: organization } = await api.get<IOrganizationApiModel>(
    '/users/organization',
  );

  return Organization.fromApiModel(organization);
};

export { getOrganization };
